module.exports = __webpack_public_path__ + "static/media/forEndorsement.bace5763.png";